import { Component } from '@angular/core';
import { SimplifiedHeaderComponent } from '../simplified-header/simplified-header.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-terms-of-service-page',
  standalone: true,
  imports: [SimplifiedHeaderComponent],
  templateUrl: './terms-of-service-page.component.html',
  styleUrl: './terms-of-service-page.component.scss',
})
export class TermsOfServicePageComponent {
  policyContent: SafeHtml = '';

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.http
      .get('assets/documents/TerminiDiServizio.html', { responseType: 'text' })
      .subscribe((content) => {
        this.policyContent = this.sanitizer.bypassSecurityTrustHtml(content);
      });
  }
}
